import { HttpParams } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { IAppState } from '../../store/common/interfaces/app-state.interface';
import { selectUserProfileId } from '../../store/nowaccount/reducers+selectors/user-profile.selector';
import {
  selectEmail,
  selectFirstName,
  selectLastName,
} from '../../store/onboarding/reducers+selectors/create-account.selector';
import { selectEnrollmentId } from '../../store/onboarding/reducers+selectors/enrollment.selector';

// https://angular.io/guide/http-configure-http-url-parameters
// "The HttpParams object is immutable. If you need to update the options, save the returned value of the .set() method."

export function applyEnrollmentIdToQueryParams(
  params: HttpParams,
  store: Store<IAppState>,
): HttpParams {
  let result: HttpParams | null = null;
  const sub = store
    .select(selectEnrollmentId)
    .subscribe((prop: { enrollmentId: string }) => {
      result = params.set('enrollmentId', prop.enrollmentId);
    });
  sub.unsubscribe();
  return result ?? params;
}

export function applyUserEmailToQueryParams(
  params: HttpParams,
  store: Store<IAppState>,
): HttpParams {
  let result: HttpParams | null = null;
  const sub = store.select(selectEmail).subscribe((prop: string) => {
    result = params.set('userEmail', prop);
  });
  sub.unsubscribe();
  return result ?? params;
}

export function applyUserFirstNameToQueryParams(
  params: HttpParams,
  store: Store<IAppState>,
): HttpParams {
  let result: HttpParams | null = null;
  const sub = store.select(selectFirstName).subscribe((prop: string) => {
    result = params.set('userFirstName', prop);
  });
  sub.unsubscribe();
  return result ?? params;
}

export function applyUserLastNameToQueryParams(
  params: HttpParams,
  store: Store<IAppState>,
): HttpParams {
  let result: HttpParams | null = null;
  const sub = store.select(selectLastName).subscribe((prop: string) => {
    result = params.set('userLastName', prop);
  });
  sub.unsubscribe();
  return result ?? params;
}

export function applyUserProfileId(
  params: HttpParams,
  store: Store<IAppState>,
) {
  let result: HttpParams | null = null;
  const sub = store
    .select(selectUserProfileId)
    .subscribe((prop: { userProfileId: number }) => {
      result = params.set('userProfileId', prop.userProfileId);
    });
  sub.unsubscribe();
  return result ?? params;
}
